var _radialGradient, _ellipse, _ellipse2, _ellipse3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcLoadingAnimationV2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 100 100",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("defs", null, _radialGradient || (_radialGradient = /*#__PURE__*/React.createElement("radialGradient", {
    id: "Gradient-0",
    cx: 0,
    cy: 0,
    r: 25,
    fx: 0,
    fy: 0,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#00ffbe"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0c9f7b"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "Mask-1",
    style: {
      maskType: "alpha"
    }
  }, _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    rx: 25,
    ry: 25,
    stroke: "#3bd4ae",
    fill: "none",
    strokeWidth: 10,
    strokeLinejoin: "bevel",
    transform: "translate(-16,-16)"
  })))), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    rx: 25,
    ry: 25,
    stroke: "#0c9f7b",
    fill: "none",
    strokeWidth: 10,
    strokeLinejoin: "bevel",
    transform: "translate(50,50)"
  })), _ellipse3 || (_ellipse3 = /*#__PURE__*/React.createElement("ellipse", {
    id: "_a0",
    rx: 50,
    ry: 50,
    fill: "url(#Gradient-0)",
    fillRule: "evenodd",
    mask: "url(#Mask-1)",
    transform: "translate(50,50) translate(16,16)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcLoadingAnimationV2);
export default __webpack_public_path__ + "static/media/ic_loading_animation_v2.64738849085e3eee658a2622d8c47d74.svg";
export { ForwardRef as ReactComponent };